import React, { Component } from 'react';
import VerticalLayout from "../../components/VerticalLayout/";
import TimelineData from './TimelineData';

class Timeline extends Component {
    constructor(props) {
        super(props);
        this.state = {
           
        }        
    }
    componentDidCatch(){
        
        localStorage.getItem("authUser")?this.props.history.push('/itineraries'):this.props.history.push('/404')
    }


    render() {
        
        let user = false
        if (localStorage.getItem("authUser")) {
        user = true 
        }
            
        return (
            user? 
                <VerticalLayout>
                    <TimelineData 
                    id = {this.props.match.params.id}
                    history = {this.props.history}
                    user = {user}
                    // name = {this.props.match.params.name}
                    />

                </VerticalLayout>
            :
                
                <TimelineData 
                id = {this.props.match.params.id}
                history = {this.props.history}
                user = {user}
                // name = {this.props.match.params.name}
                />
               
        );
    }
}

export default Timeline;


